import React, { useState } from "react";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Typography,

} from "@material-ui/core";

import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { makeStyles } from "@material-ui/core/styles";
import SettingsIcon from "@material-ui/icons/Settings";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import axios from "axios";
import { BACKEND_BASE_URL } from "../../config";
import { Switch } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  headerCell: {
    fontWeight: "bold",
    backgroundColor: "#152F8F", // Set header background color
    color: "white", // Set header text color
    border: "1px solid #ddd", // Add border to header cells
  },
  header: {
    position: "sticky",
    top: 0,
    backgroundColor: "#152F8F",
    color: "white",
    zIndex: 1000, // Ensures header stays above body content
  },
  tableBodyWrapper: {
    maxHeight: "calc(100vh - 200px)", // Adjust based on header height
    overflowY: "auto", // Allows vertical scrolling of table body
    position: "relative",
    "&::-webkit-scrollbar": {
      width: "0px", // Hides scrollbar
      background: "transparent",
    },
  },
  table: {
    border: "1px solid #ddd", // Add border to the entire table
    minWidth: "1000px", // Ensures the table is wider than the screen
  },
  tableContainer: {
    position: "relative", // Ensures relative positioning
    width: "100%",
    height: "calc(100vh - 150px)", // Adjust height to fit within the viewport
    display: "flex",
    flexDirection: "column",
  },

  tableWrapper: {
    marginBottom: theme.spacing(2),
    flexGrow: 1, // Makes it expand within the container
    overflowX: "auto", // Allows horizontal scrolling
    overflowY: "auto", // Allows vertical scrolling
    position: "relative", // Ensures proper positioning


  },
  responsiveTable: {
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.875rem", // Adjust font size for smaller screens
    },
  },
  headerCell: {
    color: "white",
    fontWeight: "bold",
    whiteSpace: "nowrap",
    padding: "6px 12px",
    fontSize: "0.9rem",
  },
  responsiveCell: {
    border: "1px solid #ddd",
    padding: "4px 8px",
    whiteSpace: "nowrap",
    fontSize: "0.85rem",
    maxWidth: "150px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    [theme.breakpoints.down("sm")]: {
      fontSize: "0.75rem",
      padding: "2px 4px",
    },
  },
  responsiveButton: {
    [theme.breakpoints.down("sm")]: {
      padding: "4px",
    },
  },
  scrollbarContainer: {
    position: "fixed", // Fixes the scrollbar at the bottom
    bottom: 0, // Keeps it at the bottom of the screen
    left: 0,
    width: "100%",
    backgroundColor: "#fff", // Optional: background color for visibility
    borderTop: "1px solid #ddd",
    padding: "5px 0",
    zIndex: 1000, // Ensures it stays above other elements
  },

  narrowCell: {
    width: "80px", // adjust this as needed
    maxWidth: "80px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  scrollbar: {
    width: "100%",
    overflowX: "scroll",
  },


  propertiesCell: {
    // backgroundColor: "#fff",   // white background for data cells
    color: "#222",             // normal text/icon color (defaults)
    border: "1px solid #ddd",
  },


}));

const StateTable = ({ data, onEdit, onDelete, currentPage,
  itemsPerPage, onToggle }) => {
  const classes = useStyles();
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedId, setSelectedId] = useState(null);


  // ====================================properties==============================================
  const [propertiesAnchorEl, setPropertiesAnchorEl] = useState(null);
  const [selectedMunicipality, setSelectedMunicipality] = useState(null);
  // =============================================================================================

  // const toggleActive = async (municipalityId, townCode, currentStatus, captureId = null) => {
  //   const newStatus = !currentStatus;

  //   // Optimistic UI update
  //   if (onToggle) {
  //     onToggle(municipalityId, newStatus);
  //   }

  //   try {
  //     if (newStatus) {
  //       // ✅ Toggle ON → Send POST request
  //       await axios.post(`${BACKEND_BASE_URL}/api/capture/aware-capture-config/`, {
  //         municipality: municipalityId,
  //         town_code: townCode,
  //         enabled: true,
  //       });
  //       console.log(`Successfully enabled capture for town: ${townCode}`);
  //     } else {
  //       // ✅ Toggle OFF → Send DELETE request
  //       if (!captureId) {
  //         throw new Error("Capture ID is required for deletion.");
  //       }
  //       await axios.delete(`${BACKEND_BASE_URL}/api/capture/aware-capture-config/${captureId}/`);
  //       console.log(`Successfully disabled capture for town: ${townCode}`);
  //     }
  //   } catch (error) {
  //     console.error("Failed to update aware capture config", error);
  //     // Revert UI state if API call fails
  //     if (onToggle) {
  //       onToggle(municipalityId, currentStatus);
  //     }
  //   }
  // };

  const toggleActive = async (municipalityId, townCode, currentStatus, captureId) => {
  const newStatus = !currentStatus;

  try {
    if (newStatus) {
      // ENABLE → POST
      const res = await axios.post(`${BACKEND_BASE_URL}/api/capture/aware-capture-config/`, {
        municipality: municipalityId,
        town_code: townCode,
        enabled: true,
      });

      if (res.data?.status === "error" && res.data?.message) {
        // Show error message from backend (e.g., YouTube URL conflict)
        alert(res.data.message);
        return;
      }

      const newId = res.data?.data?.id;
      console.log("POST CREATED → ID:", newId);

      // ⭐ ONLY THIS — update UI with the ID so disable can work
      onToggle(municipalityId, true, newId);
    }

    else {
      // DISABLE → DELETE
      console.log("Trying to disable. Current captureId:", captureId);

      if (!captureId) {
        console.warn("NO CAPTURE ID → cannot disable yet.");
        return;
      }

      await axios.delete(`${BACKEND_BASE_URL}/api/capture/aware-capture-config/${captureId}/`);
      console.log("DELETE SUCCESS → disabled");

      onToggle(municipalityId, false, null);
    }
  } catch (err) {
    console.error("ERROR:", err);
    if (err.response?.data?.message) {
      alert(err.response.data.message);
    } else {
      alert("An error occurred while updating Aware Capture status.");
    }
  }
};



  const handleDeleteDialogOpen = (id) => {
    setSelectedId(id);
    setOpenDeleteDialog(true);
  };

  const handleDeleteDialogClose = () => {
    setSelectedId(null);
    setOpenDeleteDialog(false);
  };

  const handleDeleteConfirm = () => {
    onDelete(selectedId);
    setOpenDeleteDialog(false);
  };
  //  =====================================properties=========================================
  const handlePropertiesClick = (event, municipality) => {
    setPropertiesAnchorEl(event.currentTarget);
    setSelectedMunicipality(municipality);
  };

  const handlePropertiesClose = () => {
    setPropertiesAnchorEl(null);
    setSelectedMunicipality(null);
  };
  return (
    <>
      <div className={classes.tableContainer}>
        <div className={classes.tableWrapper}>
          <Table className={`${classes.table} ${classes.responsiveTable}`}>
            <TableHead className={classes.header}>
              <TableRow>
                <TableCell className={classes.headerCell} style={{ width: '50px', minWidth: '50px' }}>S.No.</TableCell>
                <TableCell className={`${classes.headerCell} ${classes.narrowCell}`}>Country</TableCell>
                <TableCell className={`${classes.headerCell} ${classes.narrowCell}`}>State</TableCell>
                <TableCell className={`${classes.headerCell} ${classes.narrowCell}`}>County</TableCell>
                <TableCell className={classes.headerCell}>Town</TableCell>
                <TableCell className={classes.headerCell}>Population</TableCell>
                <TableCell className={classes.headerCell}>Latitude</TableCell>
                <TableCell className={classes.headerCell}>Longitude</TableCell>
                <TableCell className={classes.headerCell}>Actions</TableCell>
                {/* aware capture */}
                <TableCell className={classes.headerCell} align="center">
                  Aware Capture
                </TableCell>

              </TableRow>
            </TableHead>
            <TableBody className={classes.table}>
              {data.map((entry, index) => (
                <TableRow key={entry.id}>
                  <TableCell>{(currentPage - 1) * itemsPerPage + index + 1}.</TableCell>
                  <TableCell className={`${classes.responsiveCell} ${classes.narrowCell}`}>{entry?.country__name}</TableCell>
                  <TableCell className={`${classes.responsiveCell} ${classes.narrowCell}`}>{entry?.state}</TableCell>
                  <TableCell className={`${classes.responsiveCell} ${classes.narrowCell}`}>{entry?.county}</TableCell>
                  <TableCell className={classes.responsiveCell}>{entry?.municipality_name}</TableCell>
                  <TableCell className={classes.responsiveCell}>{entry?.population?.toLocaleString()}</TableCell>
                  <TableCell className={classes.responsiveCell}>{entry?.latitude}</TableCell>
                  <TableCell className={classes.responsiveCell}>{entry?.longitude}</TableCell>
                  <TableCell
                    style={{
                      alignItems: "center",
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <IconButton
                      variant="contained"
                      className={classes.responsiveButton}
                      style={{ marginRight: "10px", backgroundColor: "#0B194A", color: "white" }}
                      onClick={() => onEdit(entry)}
                    >
                      <EditIcon />
                    </IconButton>
                    <IconButton
                      variant="contained"
                      className={classes.responsiveButton}
                      style={{ color: "white", backgroundColor: "red" }}
                      onClick={() => handleDeleteDialogOpen(entry.id)}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                  {/* aware capture */}
                  <TableCell align="center">
                    <Switch
                      checked={entry.capture_enabled === true}
                      onChange={() =>
                        toggleActive(
                          entry.id,
                          entry.municipality_name,
                          entry.capture_enabled,
                          entry.capture_id
                        )
                      }
                      color="primary"
                      inputProps={{ "aria-label": "aware capture toggle" }}
                    />
                  </TableCell>

                </TableRow>
              ))}
            </TableBody>

          </Table>
        </div>
      </div>

      {/* ====================================== */}

      {/* aware capture */}
      <Menu
        anchorEl={propertiesAnchorEl}
        open={Boolean(propertiesAnchorEl)}
        onClose={handlePropertiesClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <MenuItem onClick={() => {
          // Add navigation logic here
          window.location.href = `/app/capture-events?municipalityId=${selectedMunicipality?.id}`;
          handlePropertiesClose();
        }}>
          Manage Capture
        </MenuItem>
        <MenuItem onClick={() => {
          // Add navigation logic here
          window.location.href = `/app/manage-meeting?municipalityId=${selectedMunicipality?.id}`;
          handlePropertiesClose();
        }}>
          Meeting Setup
        </MenuItem>
      </Menu>

      {/* ====================================== */}

      {/* Delete Confirmation Dialog */}
      <Dialog open={openDeleteDialog} onClose={handleDeleteDialogClose} maxWidth="md">
        <DialogTitle sx={{ fontWeight: "bold", textAlign: "center" }}>
          Confirm Deletion
        </DialogTitle>
        <DialogContent sx={{ textAlign: "center", p: 3 }}>
          <Typography variant="body1">
            If you delete this entry, all related URLs, transcripts, and summaries
            associated with this town will be permanently removed.
          </Typography>
          <Typography variant="body1" sx={{ mt: 1, fontWeight: "bold", color: "red" }}>
            Are you sure you want to proceed?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
          <Button onClick={handleDeleteDialogClose} variant="outlined" color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleDeleteConfirm}
            sx={{ backgroundColor: "#0B194A", color: "white", "&:hover": { backgroundColor: "#081233" } }}
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>

    </>
  );
};

export default StateTable;
